<template>
  <div id="app">
    <router-view />
    <notification-alert />
  </div>
</template>

<script>
import NotificationAlert from '@/components/NotificationAlert'

export default {
  components: {
    NotificationAlert
  },
  computed: {
    notification () {
      return this.$store.state.ui.notification
    }
  }
}
</script>

<style lang="scss">
@import './styles/app';
</style>
